import AssociatedContactsSelector from '@app/components/AssociatedContactsSelector'
import AssociatedPropertySelector from '@app/components/AssociatedPropertySelector'
import DateSelector from '@app/components/DateSelector'
import FormGroupRenderer from '@app/components/FormGroupRenderer'
import MentionEditor from '@app/components/MentionEditor'
import { SignTransfer } from '@app/models/SignTransfer'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { actionCreators, ISignTransferState } from '../modules/signTransfer'

type SignTransferModalProps = ISignTransferState & typeof actionCreators

interface ISignTransferModalState {
  isValid: boolean
}

export default class SignTransferModal extends React.PureComponent<
  SignTransferModalProps,
  ISignTransferModalState
> {
  private formRef: React.RefObject<HTMLFormElement>

  constructor(props: SignTransferModalProps) {
    super(props)
    this.formRef = React.createRef()
    this.state = {
      isValid: false,
    }
    bindFunctions(this)
  }

  public componentDidUpdate() {
    if (this.formRef.current) {
      this.setState({
        isValid: this.formRef.current.checkValidity(),
      })
    }
  }

  public render() {
    if (!this.props.signTransfer) {
      return null
    }

    return (
      <Modal
        centered
        isOpen={this.props.isOpen}
        size='lg'
        toggle={this._onClose}
      >
        <ModalHeader toggle={this._onClose}>New Sign Tranfer</ModalHeader>
        <ModalBody>
          <form ref={this.formRef} autoComplete='off'>
            <FormGroupRenderer labelText='From Property'>
              {this.props.signTransfer.from.name}
            </FormGroupRenderer>
            <FormGroupRenderer labelText='Sign Type'>
              {this.props.signTransfer.signType.name}
            </FormGroupRenderer>
            <FormGroupRenderer
              labelText={`Quantity (max ${this.props.maxQuantity})`}
              min={1}
              max={this.props.maxQuantity}
              name='Quantity'
              onChange={this.props.setQuantity}
              required
              step='1'
              type='number'
              value={this.props.signTransfer.quantity}
            />
            <hr />
            <FormGroupRenderer labelText='To Property'>
              <AssociatedPropertySelector
                name='ToProperty'
                onChange={this.props.setTo}
                required
                value={this.props.signTransfer.to}
              />
            </FormGroupRenderer>
            <FormGroupRenderer labelText='Assigned To'>
              <AssociatedContactsSelector
                name='AssignedTo'
                onChange={this.props.setAssignedTo}
                required
                value={this.props.signTransfer.assignment.assignedTo}
              />
            </FormGroupRenderer>
            <FormGroupRenderer labelText='Due Date'>
              <DateSelector
                onChange={this.props.setDueDate}
                value={this.props.signTransfer.assignment.dueDate}
              />
            </FormGroupRenderer>
            <FormGroupRenderer labelText='Transfer Notes'>
              <MentionEditor
                compact
                classNames='form-control'
                id='sign-transfer-notes'
                editorState={this.props.signTransfer.assignment.markupState}
                onChange={this.props.setNotes}
                placeholder='Enter a note...'
              />
            </FormGroupRenderer>
          </form>
        </ModalBody>
        <ModalFooter>
          <Button color='secondary' onClick={this._onClose} outline>
            <FontAwesomeIcon icon={['fal', 'times']} fixedWidth /> Cancel
          </Button>
          <Button
            color='primary'
            disabled={!this.state.isValid || this.props.isSaving}
            onClick={this._onSave}
          >
            <FontAwesomeIcon icon={['fal', 'save']} fixedWidth /> Save
          </Button>
        </ModalFooter>
      </Modal>
    )
  }

  private _isValid() {
    return (
      this.props.signTransfer !== undefined &&
      this.formRef.current !== null &&
      this.formRef.current.checkValidity()
    )
  }

  private _onClose() {
    this.props.closeSignTransferModal()
  }

  private _onSave() {
    if (this.props.signTransfer && this._isValid()) {
      this.props.saveSignTransfer(this.props.signTransfer as SignTransfer)
    }
  }
}
